module.exports = __webpack_public_path__ + "img/current_accounts.e68335c.svg";